module.exports = __webpack_public_path__ + "img/task_outlined.eaea2efc.svg";